import { render } from "./button2.vue?vue&type=template&id=00e58bed&scoped=true&ts=true"
import script from "./button2.vue?vue&type=script&lang=ts"
export * from "./button2.vue?vue&type=script&lang=ts"

import "./button2.vue?vue&type=style&index=0&id=00e58bed&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e58bed"]])

export default __exports__